const NAV_MODAL_IDS = ['search-mask', 'cart']

function getModalInstance(id) {
  const el = document.getElementById(id)
  if (!el || !window.__MODAL__) {
    return null
  }

  return window.__MODAL__.getInstance(el)
}

function isModalOpen(id) {
  const el = document.getElementById(id)
  return Boolean(el?.classList.contains('show'))
}

function hasOtherOpenNavModal(id) {
  return NAV_MODAL_IDS.some(modalId => modalId !== id && isModalOpen(modalId))
}

export function useNavModalToggles() {
  const showContact = ref(false)
  const showSearch = ref(false)
  const showCart = ref(false)

  const contactButtonDesktop = ref(null)
  const contactButtonMobile = ref(null)
  const searchButtonDesktop = ref(null)
  const searchButtonMobile = ref(null)
  const cartButtonDesktop = ref(null)
  const cartButtonMobile = ref(null)

  const hasActiveNavToggle = computed(() => {
    return showContact.value || showSearch.value || showCart.value
  })

  const contactPopoverIgnoreElements = computed(() => [
    contactButtonDesktop,
    contactButtonMobile,
    searchButtonDesktop,
    searchButtonMobile,
    cartButtonDesktop,
    cartButtonMobile,
  ])

  function handleModalShown(event) {
    const id = event.target?.id
    if (id === 'search-mask') {
      showSearch.value = true
    }
    if (id === 'cart') {
      showCart.value = true
    }
  }

  function handleModalHidden(event) {
    const id = event.target?.id
    if (id === 'search-mask') {
      showSearch.value = false
    }
    if (id === 'cart') {
      showCart.value = false
    }
  }

  function closeNavModal(id) {
    getModalInstance(id)?.hide()
  }

  function openNavModal(id) {
    const showModal = () => {
      const instance = getModalInstance(id)
      if (!instance || isModalOpen(id)) {
        return Boolean(instance)
      }

      instance.show()
      return true
    }

    const tryOpen = (attemptsLeft = 10) => {
      if (showModal() || isModalOpen(id)) {
        return
      }

      if (attemptsLeft > 0) {
        requestAnimationFrame(() => tryOpen(attemptsLeft - 1))
      }
    }

    if (hasOtherOpenNavModal(id)) {
      const onOtherHidden = (event) => {
        const targetId = event.target?.id
        if (!NAV_MODAL_IDS.includes(targetId) || targetId === id) {
          return
        }

        document.removeEventListener('hidden.bs.modal', onOtherHidden)
        tryOpen()
      }

      document.addEventListener('hidden.bs.modal', onOtherHidden)
      return
    }

    tryOpen()
  }

  function closeOtherNavToggles(activeKey) {
    if (activeKey !== 'contact') {
      showContact.value = false
    }

    if (activeKey !== 'search') {
      closeNavModal('search-mask')
      showSearch.value = false
    }

    if (activeKey !== 'cart') {
      closeNavModal('cart')
      showCart.value = false
    }
  }

  function toggleContact() {
    if (showContact.value) {
      showContact.value = false
      return
    }

    closeOtherNavToggles('contact')
    showContact.value = true
  }

  function closeContact() {
    showContact.value = false
  }

  return {
    hasActiveNavToggle,
    showContact,
    showSearch,
    showCart,
    contactButtonDesktop,
    contactButtonMobile,
    searchButtonDesktop,
    searchButtonMobile,
    cartButtonDesktop,
    cartButtonMobile,
    contactPopoverIgnoreElements,
    handleModalShown,
    handleModalHidden,
    closeNavModal,
    openNavModal,
    closeOtherNavToggles,
    toggleContact,
    closeContact,
  }
}
